// Event keeps hook instances / tabs in sync on change.
export const TEMPERATURE_UNIT_STORAGE_KEY = 'telemetryTemperatureUnit';
export const TEMPERATURE_UNIT_CHANGED_EVENT = 'telemetryTemperatureUnitChanged';
